import { GetFromLocalStorage, IsStringEmpty } from '../../utilities/CommonMethods';
import Constants from '../../utilities/Constants';
import * as actionTypes from '../actions/actionTypes';

const initialState = {
    topbarTheme: GetFromLocalStorage(Constants.KEY_USER_LOGGED_IN) === 'true' && !IsStringEmpty(GetFromLocalStorage(Constants.KEY_USERNAME)) ? 'Light' : 'Dark',
    userLoggedIn: GetFromLocalStorage(Constants.KEY_USER_LOGGED_IN) === 'true' && !IsStringEmpty(GetFromLocalStorage(Constants.KEY_USERNAME)),

    userDetails: {
        userProfilePic: GetFromLocalStorage(Constants.KEY_PROFILE_PIC),
        username: GetFromLocalStorage(Constants.KEY_USERNAME),
        fullName: GetFromLocalStorage(Constants.KEY_FULL_NAME),
        email: GetFromLocalStorage(Constants.KEY_EMAIL),
        userId: GetFromLocalStorage(Constants.KEY_USER_ID),
        isLearner: GetFromLocalStorage(Constants.KEY_IS_LEARNER),
        learnerBadge: GetFromLocalStorage(Constants.KEY_LEARNER_BADGE),
        placementAssistance: false
    },
    learnerLiveSessionStarted: false,
    liveSessionData: {},

    unreadNotifCount: 0,
    signInModalOpen: false,
    forgotPasswordModalOpen: false,
    ongoingProgramDetails: {},
    enrolledProgramsList: [],
    continueLearningData: {},
    activeProgramId: '',
    activeProgramBatchCode: '',

    activeModuleId: '',
    activeModuleName: '',
    moduleOverviewData: {},
    enrolledModulesList: [],
    ongoingModuleData: {},

    showProgramDetailsTopbar: false,
    showTopbarProgramProgress: true,
    showModuleProgress: true,
    showQuizNavbar: false,
    hideTopbar: false,

    showSuccessDialog: false,
    successDialogMessage: '',
    successDialogButtonLabel: '',
    showFailureDialog: false,
    failureDialogMessage: '',
    failureDialogButtonLabel: '',
    somethingWentWrong: false,
    notFound: false,
    unauthorized: false,
    showSessionExpiredDialog: false,

    redirectToHome: false,
    reattemptDates: {
        PYTHON: ['9 Jan 2022', '30 Jan 2022', '20 Feb 2022', '27 Feb 2022', '13 Mar 2022'],
        NEM: ['16 Jan 2022', '13 Feb 2022', '13 Mar 2022'],
        DSA: ['16 Jan 2022', '30 Jan 2022', '20 Feb 2022', '20 Mar 2022'],
        DA: [],
        DWML: [],
        DADWML: ['23 Jan 2022', '6 Feb 2022', '6 Mar 2022', '27 Mar 2022'],
        REACTJS: ['30 Jan 2022', '20 Feb 2022', '20 Mar 2022'],
        WDF: ['13 Mar 2022', '27 Mar 2022'],
        JAVA: ['9 Jan 2022', '23 Jan 2022', '13 Feb 2022', '20 Mar 2022'],
        SPRING: ['27 Feb 2022', '6 Mar 2022', '27 Mar 2022']
    },
    hideProgramStrip: true
}

const reducer = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.USER_LOGIN:
            return {
                ...state,
                userLoggedIn: action.userLoggedInStatus,
                topbarTheme: 'Light',
                signInModalOpen: false,
                redirectToHome: false
            };
        case actionTypes.USER_LOGOUT:
            return {
                ...state,
                userLoggedIn: action.userLoggedInStatus,
                topbarTheme: 'Dark',
                userDetails: {
                    userProfilePic: null,
                    username: null,
                    fullName: null,
                    email: null,
                    userId: null,
                    isLearner: null,
                    placementAssistance: null
                },
                learnerLiveSessionStarted: false,
                liveSessionData: {},

                unreadNotifCount: 0,
                signInModalOpen: false,
                forgotPasswordModalOpen: false,
                ongoingProgramDetails: {},
                enrolledProgramsList: [],
                continueLearningData: {},
                activeProgramId: '',
                activeProgramBatchCode: '',

                activeModuleId: '',
                activeModuleName: '',
                moduleOverviewData: {},
                enrolledModulesList: [],
                ongoingModuleData: {},

                showProgramDetailsTopbar: false,
                showTopbarProgramProgress: true,
                showModuleProgress: true,
                showQuizNavbar: false,

                showSuccessDialog: false,
                successDialogMessage: '',
                successDialogButtonLabel: '',
                showFailureDialog: false,
                failureDialogMessage: '',
                failureDialogButtonLabel: '',
                somethingWentWrong: false,
                notFound: false,
                unauthorized: false,
                showSessionExpiredDialog: false,
                hideProgramStrip: true
            };
        case actionTypes.SET_TOPBAR_THEME:
            return {
                ...state,
                topbarTheme: action.theme
            };
        case actionTypes.OPEN_SIGN_IN_MODAL:
            return {
                ...state,
                signInModalOpen: action.value
            }

        case actionTypes.OPEN_FORGOT_PASSWORD_MODAL:
            return {
                ...state,
                forgotPasswordModalOpen: action.value
            }
        case actionTypes.SET_BASIC_USER_DETAILS:
            return {
                ...state,
                userDetails: {
                    userProfilePic: action.userDetails.profilePic,
                    username: action.userDetails.username,
                    userId: action.userDetails.userId,
                    fullName: action.userDetails.fullName,
                    email: action.userDetails.email,
                    isLearner: action.userDetails.isLearner,
                    placementAssistance: action.userDetails.placementAssistance
                },
                unreadNotifCount: action.userDetails.unreadNotifCount,
            }
        case actionTypes.SET_INITIAL_PROGRAM_DATA:
            return {
                ...state,
                continueLearningData: action.continueLearningData,
                ongoingProgramDetails: action.ongoingProgramData,
                enrolledProgramsList: action.enrolledProgramsData,
                // hideProgramStrip: action.ongoingProgramData.type === 'micro_degree' ? false : true,
                hideProgramStrip: true,
                unauthorized: false,
                notFound: false,
                somethingWentWrong: false
            }
        case actionTypes.SET_INITIAL_MODULE_DATA:
            return {
                ...state,
                moduleOverviewData: action.moduleOverviewData,
                ongoingModuleData: action.ongoingModuleData,
                enrolledModulesList: action.enrolledModules,
                unauthorized: false,
                notFound: false,
                somethingWentWrong: false
            }
        case actionTypes.SET_CONTINUE_LEARNING_DATA:
            return {
                ...state,
                continueLearningData: action.continueLearningData,
                redirectToHome: false
            }
        case actionTypes.SET_ONGOING_PROGRAM_DATA:
            return {
                ...state,
                ongoingProgramDetails: action.ongoingProgramData,
                redirectToHome: false
            }
        case actionTypes.SET_ENROLLED_PROGRAMS_DATA:
            return {
                ...state,
                enrolledProgramsList: action.enrolledProgramsData
            }
        case actionTypes.SET_ACTIVE_PROGRAM_ID:
            const localStorage = GetFromLocalStorage(Constants.KEY_PROGRAM_STRIP) === 'true' ? true : false;
            const currentStripStatus = state.hideProgramStrip;
            const updatedStatus = !IsStringEmpty(action.programType) ? action.programType === 'micro_degree' && !localStorage ? false : true : currentStripStatus;

            return {
                ...state,
                activeProgramId: action.programId,
                activeProgramBatchCode: action.programBatchCode,
                // hideProgramStrip: updatedStatus 
                hideProgramStrip: true
            }
        case actionTypes.SET_ACTIVE_MODULE_ID:
            return {
                ...state,
                activeProgramBatchCode: action.batchCode,
                activeModuleId: action.moduleId,
                activeModuleName: action.moduleName,
            }
        case actionTypes.SET_UNREAD_NOTIF_COUNT:
            return {
                ...state,
                unreadNotifCount: action.updatedCount
            }

        case actionTypes.SETUP_PROGRAM_DETAILS_TOPBAR:
            return {
                ...state,
                showProgramDetailsTopbar: action.showTopbar,
                showTopbarProgramProgress: action.showProgramProgress,
                showModuleProgress: action.showModuleProgress,
                hideTopbar: action.hideTopbar,
                showSessionExpiredDialog: false
            }

        case actionTypes.ON_FAILURE_DIALOG_SHOW:
            return {
                ...state,
                showFailureDialog: true,
                failureDialogMessage: action.message,
                failureDialogButtonLabel: action.buttonLabel
            }

        case actionTypes.ON_FAILURE_DIALOG_HIDE:
            return {
                ...state,
                showFailureDialog: false,
                failureDialogMessage: action.message,
                failureDialogButtonLabel: action.buttonLabel
            }

        case actionTypes.ON_SUCCESS_DIALOG_SHOW:
            return {
                ...state,
                showSuccessDialog: true,
                successDialogMessage: action.message,
                successDialogButtonLabel: action.buttonLabel
            }

        case actionTypes.ON_SUCCESS_DIALOG_HIDE:
            return {
                ...state,
                showSuccessDialog: false,
                successDialogMessage: action.message,
                successDialogButtonLabel: action.buttonLabel
            }

        case actionTypes.REDIRECT_TO_UNAUTHORIZED:
            return {
                ...state,
                unauthorized: true
            }

        case actionTypes.REDIRECT_TO_NOT_FOUND:
            return {
                ...state,
                notFound: true
            }

        case actionTypes.REDIRECT_TO_SERVER_ERROR:
            return {
                ...state,
                somethingWentWrong: true
            }

        case actionTypes.SHOW_QUIZ_NAVBAR:
            return {
                ...state,
                showQuizNavbar: action.showStatus
            }


        case actionTypes.ON_PROFILE_PIC_UPDATED:
            return {
                ...state,
                userDetails: {
                    ...state.userDetails,
                    userProfilePic: GetFromLocalStorage(Constants.KEY_PROFILE_PIC)
                }
            }

        case actionTypes.RESET_ALL_ERROR_PAGES:
            return {
                ...state,
                somethingWentWrong: false,
                notFound: false,
                unauthorized: false
            }

        case actionTypes.UPDATE_LEARNER_LIVE_SESSION_STATUS:
            return {
                ...state,
                learnerLiveSessionStarted: action.liveSessionStatus,
                liveSessionData: action.liveSessionData
            }
        case actionTypes.SHOW_SESSION_EXPIRED_DIALOG:
            return {
                ...state,
                showSessionExpiredDialog: action.showStatus
            }
        case actionTypes.REDIRECT_TO_HOME:
            return {
                ...state,
                redirectToHome: action.status
            }
        case actionTypes.SET_TOPBAR_STRIP_STATUS:
            return {
                ...state,
                hideProgramStrip: action.status
            }
        default:
            return state;
    }
}

export default reducer;